import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiResponseDocument } from '@opallabs/api'

type ChartById = OpalApiResponseDocument<
  'ExperimentalReadPlanBFFV1',
  200
>['data']['charts']['by_id'][string]

export const chartByIdFactory: Factory<ChartById> = Factory.define<ChartById>(
  ({ sequence }) => {
    return {
      id: uuidV4(),
      title: `Mock Chart ${sequence}`,
      data: null,
    } satisfies ChartById
  }
)
